import logger from './logger';

import api from './api';
// Dans le fichier où vous avez besoin de l'adresse IP
import config from './config';
import authHeader from './auth-header';

const API_URL = `${config.serverIP}/api/ai`;

class SearchService {
   async searchAndSaveByImage(urlImage,searchText,userId,univerId,refProdId) {
        try {
            const request={
                "urlImage" : urlImage,
                "searchText" : searchText,
                "userId" : userId,
                "univerId":univerId,
                "refProdId":refProdId
            }
            const url = `${API_URL}/appliance/searchandsave`
            logger.log('request  :', request);
            const response = await api.post(url,request,{ headers: authHeader() });
            logger.log(response.data);
            return response.data;
        } catch (error) {
            logger.log(error);
        }
    }

    async searchApplianceByImage(urlImage, searchText) {
        try {
            const request = {
                "urlImage": urlImage,
                "searchText": searchText,
            };
            const url = `${API_URL}/lenssearchscraping`;
            logger.log('request  :', request);
            const response = await api.post(url, request, { headers: authHeader() });
            logger.log(response.data);
            return response.data;
        } catch (error) {
            logger.log(error);
            throw error;
        }
    }

    async checkInvoiceByImage(urlImage) {
        try {
            const request = {
                "urlImage": urlImage,
            };
            const url = `${API_URL}/invoicechecking`;
            logger.log('request  :', request);
            const response = await api.post(url, request, { headers: authHeader() });
            logger.log(response.data);
            return response.data;
        } catch (error) {
            logger.log(error);
            throw error;
        }
    }


    async searchImage(urlImage) {
        try {
            const request={
                "urlImage" : urlImage,
            }
            logger.log('request  :', request);
            const url = `${API_URL}/images`
            const response = await api.post(url,request,{ headers: authHeader() });
            logger.log(response.data);
            return response.data;
        } catch (error) {
            logger.log(error);
            return null; // Retourne null en cas d'erreur pour un meilleur contrôle côté appelant
        }
    }
    
    async analyseFacture(file) {
        try {
            const formData = new FormData();
            formData.append('file', file);

            const url = `${API_URL}/facture/analyse`; // => Spring Boot backend: POST /api/ai/facture/analyse

            const response = await api.post(url, formData, {
                headers: {
                    ...authHeader(),
                    'Content-Type': 'multipart/form-data'
                },
            });

            logger.log("Résultat analyse facture :", response.data);
            return response.data;
        } catch (error) {
            logger.log("Erreur analyseFacture:", error);
            throw error;
        }
    }

    
}


// Créez une instance 
const SearchServiceInstance = new SearchService();

// Exportez l'instance en tant qu'export par défaut
export default SearchServiceInstance;

//export default new SearchService();
